module.exports = __webpack_public_path__ + "0a2200f86a66e7c517f98b02086739fa.pdf";